import React, { useEffect, useContext, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { BlogContext } from '../../context/BlogContext';
import { AuthContext } from '../../context/AuthContext';
import CommentSection from './CommentSection';
import { Container } from 'react-bootstrap';
import '../../style/Blog.css';

const BlogDetails = () => {
  const { id } = useParams();
  const { blogs, deleteBlog } = useContext(BlogContext);
  const { user } = useContext(AuthContext);
  const [blog, setBlog] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const foundBlog = blogs.find(b => b._id === id);
    setBlog(foundBlog);
  }, [blogs, id]);

  const handleDelete = async () => {
    await deleteBlog(id);
    navigate('/posts');
  };

  if (!blog) return <div className="text-center mt-5"></div>;

  return (
    <Container className="mt-5 mb-4">
      <div className="retro-window mb-4">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h2 className="text-center fw-bold">{blog.title}</h2>
      </div>

      <div className="retro-post-card mb-5">
      <div className="d-flex justify-content-between text-muted fst-italic fs-6 mb-4">

<p className="mb-0">
  <strong>Author:</strong>{' '}
  <Link
    to={user?.username === blog.author.username ? "/profile" : `/profile/${blog.author.username}`}
    className="author-link"
  >
    {blog.author.username}
  </Link>
</p>

          <p className="mb-0"><strong>Published:</strong> {new Date(blog.dateCreated).toLocaleDateString()}</p>
        </div>
        <p className="fs-5" style={{ whiteSpace: 'pre-wrap' }}>
          {blog.content}
        </p>
        {user && (String(user.id) === String(blog.author.userId) || user.isAdmin) && (
          <div className="d-flex justify-content-between mt-4">
            <Link to={`/posts/edit/${id}`} className="retro-button small-btn text-center w-25 me-2">Edit</Link>
            <button onClick={handleDelete} className="retro-button small-btn w-25 bg-danger text-white">Delete</button>
          </div>
        )}
      </div>

      <CommentSection blogId={id} comments={blog.comments} blogAuthorId={blog.author.userId} />
    </Container>
  );
};

export default BlogDetails;
